import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";

import { getCollection } from "../../../helper/api";
import LatestRecentNews from "../latest-recent-news";
import LatestMoreRead from "../latest-more-read";

import "./latest-news.m.css";

const LatestNews = () => {
  const storyReducer = useSelector((state) => get(state, ["storyReducer"], []));
  const makeSecondaryApiCalls = storyReducer.makeSecondaryApiCalls;
  const delay = storyReducer.delay;

  const [isVisible, setIsVisible] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [brandspotStories, setBrandspotStories] = useState([]);
  const [moreStories, setMoreStories] = useState([]);
  const [recentStories, setRecentStories] = useState([]);
  const [storyInjected, setStoryInjected] = useState(false);
  const [dataFetched, setDataFetched] = useState({
    0: false,
    1: false
  });

  const fetchBrandspotStories = () => {
    try {
      if (!brandspotStories.length) {
        getCollection("brandspot-rhs-widget", 0, 2).then((stories) => setBrandspotStories(stories));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRecentNews = async () => {
    const recentNews = await getCollection("recent-news", 0, 5);
    return recentNews;
  };

  const fetchMostNews = async () => {
    const mostReadNews = await getCollection("most-read", 0, 5);
    return mostReadNews;
  };

  useEffect(() => {
    if (makeSecondaryApiCalls) {
      setTimeout(() => {
        fetchBrandspotStories();
      }, delay);
      setTimeout(() => setIsVisible(true), delay + 500);
    }
  }, [makeSecondaryApiCalls]);

  useEffect(() => {
    if (!dataFetched[activeTab]) {
      if (activeTab === 0) {
        fetchMostNews().then((mostReadNews) => {
          setDataFetched((prevState) => ({
            ...prevState,
            0: true
          }));
          setMoreStories(mostReadNews);
        });
      } else if (activeTab === 1) {
        fetchRecentNews().then((recentNews) => {
          setDataFetched((prevState) => ({
            ...prevState,
            1: true
          }));
          setRecentStories(recentNews);
        });
      }
    }
  }, [activeTab, dataFetched]);

  useEffect(() => {
    if (!storyInjected) {
      const updatedMoreStories = [...moreStories];
      const updatedRecentStories = [...recentStories];
      if (brandspotStories[0]) {
        updatedMoreStories.splice(1, 0, brandspotStories[0]);
        updatedRecentStories.splice(1, 0, brandspotStories[0]);
      }

      if (brandspotStories[1]) {
        updatedMoreStories.splice(3, 0, brandspotStories[1]);
        updatedRecentStories.splice(3, 0, brandspotStories[1]);
        setStoryInjected(true);
      }

      setMoreStories(updatedMoreStories);
      setRecentStories(updatedRecentStories);
    }
  }, [brandspotStories, storyInjected]);

  const handleTabSwitch = (tab) => () => {
    setActiveTab(tab);
  };

  return (
    <div styleName="wrapper">
      {isVisible && (
        <div styleName="related-collection">
          <div styleName="title-wrapper">
            <div styleName={`title ${activeTab === 0 ? "active" : ""} `} onClick={handleTabSwitch(0)}>
              ಹೆಚ್ಚು ಓದಿದ ಸುದ್ದಿ
            </div>
            <div styleName={`title ${activeTab === 1 ? "active" : ""} `} onClick={handleTabSwitch(1)}>
              ಇತ್ತೀಚಿನ ಸುದ್ದಿ
            </div>
          </div>
          {activeTab === 0 ? (
            <div styleName="stories">
              <LatestMoreRead stories={moreStories} />
            </div>
          ) : (
            <div styleName="stories">
              <LatestRecentNews stories={recentStories} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LatestNews;
